import { gql } from "@apollo/client";

export const fetchRenewalRIValue = gql`
  query FetchRenewalRIValue {
    fetchRenewalRIValue
  }
`;

export const fetchUpcomingRenewals = gql`
  query FetchUpcomingRenewals {
    fetchUpcomingRenewals
  }
`;


export const fetchReinsurerShare = gql`
  query FetchReinsurerShare {
    fetchReinsurerShare {
      currency
      total_facultative_premium
    }
  }
`;

export const fetchReinsurerAverageOfferAcceptanceRate = gql`
  query FetchReinsurerAverageOfferAcceptanceRate($period: Int = 7) {
    fetchReinsurerAverageOfferAcceptanceRate(period: $period) {
      average_acceptance_time
      time_change
      fast_time
      slowest_time
      total_offers
      period
    }
  }
`;

export const fetchMarketGrowth = gql`
  query FetchMarketGrowth {
    fetchMarketGrowth {
      currency
      today_total
      yesterday_total
      market_growth
    }
  }
`;

export const fetchEstimatedRIValues = gql`
  query FetchEstimatedRIValues {
    fetchEstimatedRIValues {
      currency
      total_facultative_premium
    }
  }
`;